import fileService from "@services/common/fileService"
import type { PagedResultDto } from "@services/dto/pagedResultDto"
import pricingApprovalService from "@services/pricingApproval/pricingApprovalService"
import { action, makeAutoObservable, observable } from "mobx"

class PricingApprovalStore {
  @observable isLoading!: boolean
  @observable detailData!: any
  @observable detailOverviewData!: any
  @observable tableData!: PagedResultDto<any>
  @observable listUnitPricingHistory!: any

  constructor() {
    makeAutoObservable(this)

    this.tableData = { items: [], totalCount: 0 }
  }

  @action
  async getAll(params: any) {
    this.isLoading = true
    const result = await pricingApprovalService
      .getAll(params)
      .finally(() => (this.isLoading = false))

    this.tableData = result
  }
  @action
  async initDetail() {
    this.detailData = {
      id: undefined,
    }
  }
  @action
  async get(params: any) {
    this.isLoading = true
    const result = await pricingApprovalService
      .get(params)
      .finally(() => (this.isLoading = false))
    this.detailData = result
  }

  @action
  async createOrUpdate(body: any, files?: Array<any>) {
    this.isLoading = true
    const result = await pricingApprovalService.createOrUpdate(body)
    const { uniqueId } = result
    if (files && files.length && uniqueId) {
      const filesBody = {
        moduleName: "PricingApproval",
        uniqueId: uniqueId,
        descriptions: [...files].map((item) => item?.description),
      }

      await fileService.uploadDocumentWithModuleName(
        [...files].map((item) => item?.file),
        filesBody
      )
    }
    this.isLoading = false
    return result
  }


  @action
  async active(id: number, isActive) {
    await pricingApprovalService.active(id, isActive)
  }
  @action
  async bulkActive(ids: number[]) {
    await pricingApprovalService.bulkActive(ids)
  }
  @action
  async getOverview(id: number, body?: any) {
    this.isLoading = true
    const result = await pricingApprovalService
      .getOverview(id, body ?? [])
      .finally(() => (this.isLoading = false))
    this.detailOverviewData = result
  }

  @action
  async assignUnit(body: any) {
    this.isLoading = true
    const result = await pricingApprovalService.assignUnit(body).finally(() => {
      this.isLoading = false
    })
    return result
  }

  @action
  async getListUnitPricingHistory(params: any) {
    this.isLoading = true
    const result = await pricingApprovalService.getListUnitPricingHistory(params).finally(() => {
      this.isLoading = false
    })
    this.listUnitPricingHistory = result
    return result
  }
}

export default PricingApprovalStore
